export default "/images/vendor/flag-icon-css/flags/4x3/tk.svg?5c7cbb32d630f7d2f6586126d5e7528b";